import { CronType, PeriodType } from 'react-js-cron';

export const EmrDataParamaters = [
  {
    label: 'Facilites List',
    value: 'facilitiesSyncFreq',
  },
  {
    label: 'Facilites Structure',
    value: 'facilityStructureSyncFreq',
  },
  {
    label: 'Patients List',
    value: 'patientsSyncFreq',
  },
  {
    label: 'Patients Conditions',
    value: 'patientConditionsSyncFreq',
  },
  {
    label: 'Patients Medications',
    value: 'patientMedicationsSyncFreq',
  },
  {
    label: 'Patients Allergies',
    value: 'patientAllergiesSyncFreq',
  },
  {
    label: 'Patients Immunizations',
    value: 'patientImmunizationsSyncFreq',
  },
  {
    label: 'Patients Observations',
    value: 'patientObservationsSyncFreq',
  },
  {
    label: 'Patients Progress Notes',
    value: 'patientProgressNotesSyncFreq',
  },
  {
    label: 'Patients ADT Records',
    value: 'patientAdtRecordsSyncFreq',
  },
  {
    label: 'Push Medical Observations',
    value: 'observationsPushFreq',
  },
];

export const presetValues = {
  facilityStructureSyncFreq: '* 8 * * SUN',
  patientsSyncFreq: '0 * * * *',
  adtSyncFreq: '0 * * * *',
  additionalDataSyncFreq: '0 7 * * *',
};

export const AllowedDropdownPeriodsWithWeekDays: CronType[] = [
  'period',
  'months',
  'month-days',
  'week-days',
  'hours',
];

export const AllowedDropdownPeriodsWithoutWeekDays: CronType[] = [
  'period',
  'months',
  'month-days',
  'hours',
];

export const WeekDays = [
  { label: 'Monday', value: 'Mon' },
  { label: 'Tuesday', value: 'Tue' },
  { label: 'Wednesday', value: 'Wed' },
  { label: 'Thursday', value: 'Thu' },
  { label: 'Friday', value: 'Fri' },
  { label: 'Saturday', value: 'Sat' },
  { label: 'Sunday', value: 'Sun' },
];

export const YearMonths = [
  { label: 'January', value: 'Jan' },
  { label: 'February', value: 'Feb' },
  { label: 'March', value: 'Mar' },
  { label: 'April', value: 'Apr' },
  { label: 'May', value: 'May' },
  { label: 'June', value: 'Jun' },
  { label: 'July', value: 'Jul' },
  { label: 'August', value: 'Aug' },
  { label: 'September', value: 'Sep' },
  { label: 'October', value: 'Oct' },
  { label: 'November', value: 'Nov' },
  { label: 'December', value: 'Dec' },
];

export const ALLOWED_TIME_PERIODS: Record<string, PeriodType> = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
};
